<template>
  <div>
    <qrcode-vue
      :value="authUri"
      :size="size"
      level="H"
    />
    <div class="mt-2">
      <span>Code:</span>
      <br>
      <code>{{ code }}</code>
    </div>
    <b-form @submit.prevent="verifyTotpToken">
      <b-form-group
        label-cols-lg="2"
        :label="$t('login.mfaSetup.input.mfaotp.label')"
        label-for="input-mfaotp"
      >
        <b-form-input
          v-model="mfaotp"
          :placeholder="$t('login.mfaSetup.input.mfaotp.placeholder')"
          type="number"
          id="input-mfaotp"
          :required="true"
        />
      </b-form-group>
      <b-button
        type="submit"
        variant="primary"
        block
      >
        {{ $t('login.mfaSetup.submitButtonText') }}
      </b-button>
    </b-form>
    <b-form-input
      v-model="mfaotp"
      placeholder="Use the generated one-time password to verify the setup"
    />
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import QrcodeVue from "qrcode.vue";

export default {
  name: "MfaSetup",
  components: {
    QrcodeVue
  },
  props: {
    username: {
      type: String,
      default: ""
    },
    secret: {
      type: String,
      default: ""
    },
    cognitoUser: {
        type: Object,
        default: null
    }
  },
  data() {
    return {
      size: 300,
      user: this.username,
      code: this.secret,
      mfaotp: ""
    };
  },
  computed: {
    authUri: function() {
      return (
        "otpauth://totp/mySchindelhauer:" +
        this.user +
        "?secret=" +
        this.code +
        "&issuer=Schindelhauer"
      );
    }
  },
  methods: {
    verifyTotpToken: function() {
      // Use the generated one-time password to verify the setup
      Auth.verifyTotpToken(this.cognitoUser, this.mfaotp)
        .then(() => {
          // don't forget to set TOTP as the preferred MFA method
          Auth.setPreferredMFA(this.cognitoUser, "TOTP");
          this.$router.push({ name: "home" });
        })
        .catch(e => {
          // Token is not verified
          console.log(e);
        });
    }
  }
};
</script>